import { securityItems } from '../data';
import InformationSection from './information-section';

const SecuritySection = () => (
  <InformationSection
    title="Security and compliance"
    description="How patient data is protected, and where each certification stands."
    items={securityItems}
  />
);

export default SecuritySection;
